/**
 * Reader-facing audiobook API client (Phase 2 — playback). Follows the
 * sampleChapters/api.js fetch + `br-token` convention.
 */
const BASE = `${process.env.REACT_APP_API_HOST}/api/v2`;

const headers = idToken => ({
  'Content-Type': 'application/json',
  'br-token': idToken,
});

const handle = async res => {
  if (!res.ok) {
    let body = {};
    try {
      body = await res.json();
    } catch (e) {
      /* non-JSON error body */
    }
    const err = new Error(body.msg || `Request failed (${res.status})`);
    err.status = res.status;
    err.code = body.error;
    throw err;
  }
  return res.status === 204 ? null : res.json();
};

/** Ready audio chapters for a version (Listen toggles). */
export const getAvailableAudio = (idToken, bookId, contentVersionId) =>
  fetch(`${BASE}/books/${bookId}/content/${contentVersionId}/audio/available`, {
    headers: headers(idToken),
  }).then(handle);

/** Short-TTL signed URL + timing map for one ready chapter. */
export const getAudioStreamUrl = (idToken, bookId, contentVersionId, partId) =>
  fetch(
    `${BASE}/books/${bookId}/content/${contentVersionId}/audio/${partId}/stream-url`,
    { headers: headers(idToken) }
  ).then(handle);
